import styled from '@emotion/styled'
import DrawerPanel from 'modules/drawer/components/drawer-panel/drawer-panel'
import FlowOneColumnStepLayout from 'modules/flow/components/one-column-step-layout/one-column-step-layout'
import ThankYouStepContent from 'modules/flow/components/thank-you-step/thank-you-step-content'
import Column from 'modules/ui/atoms/Layout/Column'

const Wrapper = styled.div`
  flex: 1;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div {
    width: 100%;
    max-width: 400px;
  }
`

const OrderDetailsDrawerPanel = () => {
  return (
    <DrawerPanel>
      <DrawerPanel.Body>
        <>
          <FlowOneColumnStepLayout.Main title="" hideBackButton hideHeader>
            <Column>
              <Wrapper>
                <ThankYouStepContent />
              </Wrapper>
            </Column>
          </FlowOneColumnStepLayout.Main>
        </>
      </DrawerPanel.Body>
    </DrawerPanel>
  )
}

export default OrderDetailsDrawerPanel
